import {
    addUserToTeamFail,
    addUserToTeamSuccess,
    removeUserFromTeamFail,
    removeUserFromTeamSuccess,
    updateUserFail,
    updateUserSuccess
} from './actions';
import { put } from 'redux-saga/effects';
import { makeErrorPayload } from '../../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../../shared/toast/redux/actions';
import { fetchUsers } from '../user-list/actions';
import { addUserToTeam, removeUserFromTeam, updateUser } from '../user.backend';
import { fetchUserDetailsSuccess } from '../user-details/actions';

export function* updateUserSaga(action) {
    const { userId, details } = action.payload;
    try {
        const response = yield updateUser(userId, details);

        yield put(updateUserSuccess(response.data));
        yield put(fetchUserDetailsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(updateUserFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* addUserToTeamSaga(action) {
    const { userId, teamId } = action.payload;
    try {
        const response = yield addUserToTeam(userId, { teamId });
        yield put(addUserToTeamSuccess(response.data));
        yield put(fetchUsers());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(addUserToTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* removeUserFromTeamSaga(action) {
    const { userId, teamId } = action.payload;
    try {
        const response = yield removeUserFromTeam(userId, teamId);
        yield put(removeUserFromTeamSuccess(response.data));
        yield put(fetchUsers());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(removeUserFromTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
